

















import { computed, defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { getProfileUrl } from "@/lib/urlHelpers";
import ContentFeedCover from "@/components/ContentFeedCover";
import FormatMoney from "@/components/FormatMoney";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationLike",
  components: { NotificationItemView, ContentFeedCover, FormatMoney },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
  setup(props) {
    const contentSet = computed<ContentSet>(() => props.notification.details.content.contentSet);

    const { authUserStrict } = useAuthUser();
    const subjectUrl = computed<Location>(() => {
      return getProfileUrl(authUserStrict.value, { feedId: props.notification.subjectId });
    });

    return {
      contentSet,
      subjectUrl,
    };
  },
});
